import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import './styles/tokens.css';
import './styles/globals.css';
import './styles/app.css';
import 'calc-controls/styles.css';
import './styles/calc-controls-overrides.css';
import 'calc-nav/styles.css';
import 'calc-sidebar/styles.css';
import '@ascend/about-modal/styles.css';
import './styles/about-modal-overrides.css';
import '@ascend/alert/styles.css';
import { AlertProvider } from '@ascend/alert';
import { AppLockProvider } from './components/AppLock';
import { AppGate } from './components/AppLock';

registerSW({ onNeedRefresh() {}, onOfflineReady() {} });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <React.Suspense fallback={<div className="app-loading">Loading…</div>}>
      <AlertProvider>
        <AppLockProvider>
          <AppGate />
        </AppLockProvider>
      </AlertProvider>
    </React.Suspense>
  </React.StrictMode>,
);
